import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../store'; // поправь путь
import { Deal } from '../types';
import { buildLink, formatMoney } from '../utils';

type OwnProps = {
    finalSelection: NonNullable<Deal['finalSelection']>;
};

type StateProps = {};
type DispatchProps = {};
type Props = OwnProps & StateProps & DispatchProps;

const _FinalSelectionCard: React.FC<Props> = ({ finalSelection }) => {
    const { object, source, sourceId, closedAt } = finalSelection;
    const sourceUrl = buildLink(source, sourceId);

    return (
        <div className="mt-2 border rounded p-3 bg-green-50/40">
            <div className="text-xs font-semibold text-green-800 mb-2">Итоговый объект</div>

            <div className="flex gap-3">
                {/* изображения (первое) */}
                {object.images?.length ? (
                    <img
                        src={object.images[0]}
                        alt={object.housingName}
                        className="w-24 h-24 object-cover rounded"
                    />
                ) : null}

                <div className="min-w-0">
                    <div className="text-sm font-medium truncate">
                        {object.housingName} • {object.roomType}
                    </div>
                    <div className="text-xs text-gray-600">
                        {object.builder}{object.address ? ` • ${object.address}` : ''}
                    </div>

                    <div className="mt-1 text-xs text-gray-700">
                        Площадь: <span className="font-medium">{object.area} м²</span>{' '}
                        • Этажи: <span className="font-medium">{object.floorRange}</span>{' '}
                        • План: <span className="font-medium">{object.installmentPlan}</span>{' '}
                        • Период: <span className="font-medium">{object.installmentPeriod} мес.</span>
                    </div>

                    <div className="mt-1 text-xs text-gray-800">
                        Цена: <span className="font-semibold">{formatMoney(object.fullPrice)}</span>{' '}
                        • Первый взнос: <span className="font-semibold">{formatMoney(object.firstPayment)}</span>{' '}
                        • Остаток: <span className="font-semibold">{formatMoney(object.rest)}</span>{' '}
                        • Ежемесячно: <span className="font-semibold">{formatMoney(object.monthlyPrice)}</span>
                    </div>

                    <div className="mt-1 text-[11px] text-gray-500">
                        Цена за м²: {formatMoney(object.pricePerMeter)}
                        {closedAt ? <> • Закрыто: {new Date(closedAt).toLocaleDateString()}</> : null}
                    </div>

                    {/* ссылка на источник (вторично) */}
                    <div className="mt-2">
                        <a
                            href={sourceUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="text-xs underline text-green-700 hover:text-green-900"
                            title="Открыть источник итогового варианта"
                            onClick={(e) => e.stopPropagation()}
                        >
                            Открыть источник ({source === 'calculation' ? 'расчёт' : 'подборка'})
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (_: RootState): StateProps => ({});
const mapDispatchToProps: DispatchProps = {};

export const FinalSelectionCard = connect(mapStateToProps, mapDispatchToProps)(_FinalSelectionCard);
